import { Loadable, createDefaultLoadable } from '../../common/models/loadable';
import { AGGREGATE_PAGE_SIZE } from '../../common/constants/filter';
import {
  AggregateSpec,
  DrilldownStep,
  GroupBySpec,
  HavingSpec,
  OrderingSpec,
  PaginationSpec,
} from '../models/aggregate.models';

export interface AggregateState extends Loadable {
  active: boolean;
  hasPendingChanges: boolean;
  metricsHavingModified: boolean;
  groupBy: GroupBySpec[];
  committedGroupBy: GroupBySpec[];
  aggregates: AggregateSpec[];
  having: HavingSpec[];
  ordering: OrderingSpec[];
  pagination: PaginationSpec;
  drilldownPath: DrilldownStep[];
  // Groups the user has checkbox-selected at the current (non-leaf) level, to scope a report to just those groups.
  selectedGroups: DrilldownStep[];
  results: Record<string, any>[];
  totalGroups: number;
  totalPages: number;
  isAppending: boolean;
}

export const initialAggregateState: AggregateState = {
  ...createDefaultLoadable(),
  active: false,
  hasPendingChanges: false,
  metricsHavingModified: false,
  groupBy: [],
  committedGroupBy: [],
  aggregates: [],
  having: [],
  ordering: [],
  pagination: { per_page: AGGREGATE_PAGE_SIZE, page_num: 1 },
  drilldownPath: [],
  selectedGroups: [],
  results: [],
  totalGroups: 0,
  totalPages: 0,
  isAppending: false,
};
